import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {PageHeaderConfig} from "../../../../../../core/shared/service/page/page-header-config.interface";
import {CrCustomerObjectViewTypeUiEnum} from "./data/cr-customer-object-view-type-ui.enum";
import {ActivatedRoute, Router} from "@angular/router";
import {
    ObjectPageComponent
} from "../../../../../../core/shared/object/mvs-object-page-component/object-page.component";
import {AgentDto} from "../../../../../../feature-core/am/model/dto/entity/agent.dto";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {UmUserService} from "../../../../../../feature-core/um/service/api/um-user.service";
import {MvsObjectNavigationService} from "../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {AgentService} from "../../../../../../feature-core/am/service/api/agent.service";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestComplex} from "../../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {DtoList} from "../../../../../../core/shared/dto/dto.list";
import {UmUserDto} from "../../../../../../feature-core/um/model/dto/entity/um-user.dto";
import {CustomerDto} from "../../../../model/dto/entity/customer.dto";
import {CustomerPageHouseholdPersonService} from "../../../../service/ui/customer-page-household-person.service";
import {CustomerService} from "../../../../service/api/customer.service";
import {CrCustomerRestrictionType} from "../../../../enum/cr-customer-restriction-type.enum";
import {
    ObjectChangeInformation,
    ObjectChangeInformationActionEnum
} from "../../../../../../core/shared/logic/object-change-information";
import {Observable, Subscription} from "rxjs";
import {RestrictedCustomerUnlockLogDto} from "../../../../model/dto/entity/restricted-customer-unlock-log.dto";
import {
    CrCustomerRelatedPersonWidgetStyle
} from "../../../../component/protected-components/cr-customer-related-persons/uiStyle/cr-customer-related-person-widget-style";


@Component({
    selector: 'mvs-cr-customer-object-consultant-page',
    templateUrl: './cr-customer-object-consultant.page.html',
    styleUrls: ['./cr-customer-object-consultant.page.scss'],
    standalone: false
})
export class CrCustomerObjectConsultantPage
  extends ObjectPageComponent
  implements OnInit, OnDestroy, OnChanges {

    restrictedCustomerUnlockLogService: MvsCrudService;
  override defaultLabel: string = "Kundenansicht";
  viewType: CrCustomerObjectViewTypeUiEnum = CrCustomerObjectViewTypeUiEnum.standard;
  restrictedProfile: boolean = false;

  objectTypeId: number;
  loggedOnAgent: AgentDto;
  customerName: string;
  customerFilter: FilterCriteria[] = [];
  changedFilter: FilterCriteria;
  photoUrl: Observable<string>;
  customerDto: CustomerDto;
  customerRelatedPersonWidgetStyle: CrCustomerRelatedPersonWidgetStyle;
  displaySidebar: boolean = false;
  unlockReasonDialog: boolean = false;
  unlockReason: string = '';

  /**
   * TM-1000002005: subscription to the object-change bus, see {@link subscribeCustomerChanges}.
   */
  objectChangeSubscription: Subscription;

  constructor(
    protected userService: UmUserService,
    protected navigationService: MvsObjectNavigationService,
    protected messageService: MvsMessageService,
    protected agentService: AgentService,
    protected router: Router,
    protected override route: ActivatedRoute,
    protected override coreService: MvsCoreService,
    protected customerPageHouseholdPersonService: CustomerPageHouseholdPersonService) {
    super(route, coreService);
  }

  override ngOnInit() {

    super.ngOnInit();

        this.restrictedCustomerUnlockLogService = this.coreService.getCrudService("cr.RestrictedCustomerUnlockLog");
    this.subscribeCustomerChanges();
    this.getLoggedOnAgent();
  }

  /**
   * TM-1000002005: re-read the customer whenever the shown cr.Customer record is written anywhere.
   *
   * This page had NO bus subscription at all, so its restriction banner kept the state it was opened
   * with until the consultant reloaded the browser. The writer is the channel matrix, which sits
   * several levels below inside a dialog. This mirrors the main customer page.
   *
   * ⚠ TM-1000002005 - AND WHO RAISES THE EVENT DEPENDS ON THE ACT. This comment used to say the
   * matrix „writes through the ordinary CRUD service“ and that the write „already reports itself on
   * MvsObjectService.objectChangeEvent“. That holds for the FOUR channel-only acts („Alle gewähren“,
   * „Alle ablehnen“ and the two selection acts), which still go through MvsCrudService.update /
   * create - and MvsCrudService.subscribeBroadcastChange is the only AUTOMATIC publisher on this
   * bus; a write that bypasses the CRUD service must announce itself. The THREE acts that move the
   * cr.CustomerType („Keine Kommunikation“, „Sperrkunde“, „Kommunikation wiederherstellen“) write
   * through the atomic
   * POST /mvsa/cr/customers/{id}/applyCommunicationState, a bare HttpClient.post that announces
   * NOTHING - so for a while those three were silent and this banner was stale again. The matrix
   * publishes the cr.Customer and cr.CustomerChannel events for them itself now; see
   * CrCustomerChannelsComponent.announceCommunicationStateChange.
   *
   * ⚠ The bus must be taken from {@code coreService.getObjectService()}, i.e. the BASE
   * {@link MvsObjectService}. {@code MvsUiObjectService} overrides {@code objectChangeEvent} with a
   * Subject of its own and is therefore deaf to every CRUD write - a subscription on it compiles,
   * runs, and silently never fires.
   *
   * Deliberately NARROW - three conditions, all of them required:
   *
   *  - objectType must be OUR object type. cr.CustomerChannel is expressly NOT included: a block
   *    writes one channel row per channel type, so reacting to those would fire N redundant
   *    cr.Customer reads for data that cannot have changed.
   *  - action must be `updated`. `deleted` would send us reading a record that is gone and blank the
   *    page; no other action can carry the id of a customer that is already open.
   *  - the id must be the customer THIS page is showing. Several customer pages can be open at once
   *    (tabs, overlays), and each must react only to its own.
   */
  protected subscribeCustomerChanges(): void {

    this.objectChangeSubscription = this.coreService.getObjectService().objectChangeEvent.subscribe(
      (change: ObjectChangeInformation) => {

        if (!this.isOwnCustomerChange(change)) {
          return;
        }

        this.getCustomerName();
      });
  }

  /**
   * TM-1000002005: does this bus event describe a write to the customer this page shows?
   */
  protected isOwnCustomerChange(change: ObjectChangeInformation): boolean {

    if (!change || change.objectType != this.getObjectType()) {
      return false;
    }

    if (change.action != ObjectChangeInformationActionEnum.updated) {
      return false;
    }

    const changedId: number = change.after?.id;

    return changedId != null && changedId == this.objectIdentifier?.objectId;
  }

  /**
   * TM-1000002005: the object-change bus is an application-wide Subject - a page that does not
   * release it keeps reading customers for every tab the consultant ever opened.
   */
  override ngOnDestroy(): void {

    super.ngOnDestroy();

    if (this.objectChangeSubscription) {
      this.objectChangeSubscription.unsubscribe();
    }
  }

  protected override getObjectType(): string {
    return "cr.Customer";
  }


  protected override onRouteChangeBefore(params: any) {
    if (params["view"]) {
      this.viewType = <CrCustomerObjectViewTypeUiEnum>+params["view"];
    }
    if (params['id']) {
      if (this.objectIdentifier) {
        this.objectIdentifier = this.objectIdentifier.clone();
      }
    }

  }

  override refreshComponent() {

    this.customerPageHouseholdPersonService.setCustomerId(this.objectIdentifier.objectId);
    this.getPhoto();
    this.getCustomerName();
  }

  getPhoto() {
    const crudServiceCustomer: CustomerService = <CustomerService>this.coreService.getCrudService("cr.Customer");
    this.photoUrl = crudServiceCustomer.getPhotoUrl(this.objectIdentifier.objectId);
  }

  getCustomerName() {
    const dtoRequest: ObjectRequestList = new ObjectRequestList(
      false,
      [FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
      []);

    dtoRequest.objectRequestComplex = ObjectRequestComplex.build(false, true, ObjectRequestComplexNode.createSimpleAttributeNode('person'),
      ObjectRequestComplexNode.createSimpleAttributeNode('customerType'));


    const crudService = this.coreService.getCrudService(this.objectIdentifier.objectType);

    crudService.list(dtoRequest).subscribe((res: DtoList<CustomerDto>) => {
      this.customerDto = res.entries[0];

      if (this.customerDto && this.customerDto.personDto) {
        //rename tab
        this.customerDto.personDtoName = `${this.customerDto.personDto.firstName} ${this.customerDto.personDto.lastName}`;

        const tabName = `${this.customerDto.personDto.lastName} ${this.customerDto.personDto.firstName}`
        this.renameTab(tabName);
      }

      if (this.customerDto?.customerTypeDto?.restrictionType == CrCustomerRestrictionType.restricted) {
        this.retrieveCustomerRestrictionLog();

      } else {
        this.restrictedProfile = false;
      }
      this.handleCustomerDto(this.customerDto);
    });

  }

  retrieveCustomerRestrictionLog() {

    const now = new Date();
    const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000); // subtract 1 hour
    const oneHourAgoIso = oneHourAgo.toISOString(); // convert to ISO string


    const filterCriteria = [
      FilterCriteria.create('customer', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId),
      FilterCriteria.create('createdBy', FilterCriteria.cOperatorEqual, '${E:ME_USERNAME}'),
      FilterCriteria.create('createdDate', FilterCriteria.cOperatorGreaterThan, oneHourAgoIso),
    ]
    const objectRequestList = ObjectRequestList.createBasic(false, filterCriteria, []);
    this.restrictedCustomerUnlockLogService.list(objectRequestList).subscribe(res => {
      if (res.entries.length > 0) {
        this.restrictedProfile = false;
      } else {
        this.restrictedProfile = true;
      }
    })
  }

  unlockProfile() {
    // this.restrictedProfile = !this.restrictedProfile;
    this.unlockReasonDialog = true;
  }

  unlockCustomer() {

    if (this.busy) {
      return;
    }

    this.busy = true;

    const dto: RestrictedCustomerUnlockLogDto = new RestrictedCustomerUnlockLogDto();

    this.userService.me().subscribe((res: UmUserDto) => {
      dto.customerDtoId = this.objectIdentifier.objectId;
      dto.description = this.unlockReason;
      dto.unlockTime = new Date();
      dto.userDtoId = res.id;


      this.restrictedCustomerUnlockLogService.create(dto).subscribe(res => {
        this.unlockReasonDialog = false;
        this.restrictedProfile = false;
        this.busy = false;
      }, error => {
        this.busy = false;
      });
    }, error => {
      this.busy = false;
    })


  }

  override isBreadcrumbVisible(): boolean {
    return false;
  }

  handleCustomerFilter(event: FilterCriteria[]) {
    this.customerFilter = event;
  }

  onRemoveFilterCriteria(filter: FilterCriteria) {
    let index = this.customerFilter.findIndex(item => item.field === filter.field);

    if (index > -1) {
      this.changedFilter = filter;
      this.customerFilter.splice(index, 1);
    }
  }

  handleSelectedRelatedPersonsChanged(event: CrCustomerRelatedPersonWidgetStyle) {
    this.customerRelatedPersonWidgetStyle = event;
    this.customerRelatedPersonWidgetStyle = this.customerRelatedPersonWidgetStyle.clone();
  }


  getLoggedOnAgent() {
    this.agentService.me().subscribe(res => {
      this.loggedOnAgent = res;
      this.initialized = true;
    })
  }


  handleCustomerDto(event: CustomerDto) {
    this.customerDto = event;

    const fullName = this.customerDto?.personDtoName ?? '';
    const lastName = fullName?.trim().split(/\s+/).pop() || '';
    this.defaultLabel = `${lastName} - Kundenansicht`;

    this.setActiveTitle();
  }

  openSidebar() {
    this.displaySidebar = true;
  }

  // TM-1000001554: Do NOT return a header config here. The
  // <cr-customer-header-consultant> is rendered inline in this page's template
  // (see cr-customer-object-consultant.page.html). Returning a header config
  // would cause the shared <mvs-page-header> in the shell-consultant layout to
  // render a second instance of the same component, producing two stacked
  // headers whenever the page is opened inside an object-navigation overlay.
  getPageHeaderConfig(): PageHeaderConfig {
    return null;
  }

  protected readonly CrCustomerRestrictionType = CrCustomerRestrictionType;
}
